export default __webpack_public_path__ + "static/media/name-light.0b5ce6c9.svg";